const list = [
  '2312-29/22-2С',
  '2412-41/22-1С',
  '2312-27/22-1С',
];

export default list;
